import { useParams } from "react-router";
import { useSummaryItemReport } from "@/services/backend/htz/summary/hooks/use-summary-item-report";
import { useHtzReportShowQuery } from "@/services/backend/htz/report/api/report-api";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { PhotosComponent } from "@/routes/processes/[processId]/htz/summaries/[summaryId]/items/[itemId]/report/photos/_components/photos-component";

export function PhotosRoute() {
  const { summaryId, itemId } = useParams();
  const { reportId } = useSummaryItemReport(summaryId!, itemId!);
  const {
    data: report,
    isLoading,
    error,
  } = useHtzReportShowQuery({ id: reportId! }, { skip: !reportId });

  if (isLoading) {
    return null;
  }

  if (error) {
    return <RTKQueryErrorAlert error={error} />;
  }

  return <PhotosComponent report={report!} />;
}
